import { Injectable } from "@angular/core";
import { CdkConnectedOverlay } from "@angular/cdk/overlay";

@Injectable()
export class OverlayRepositionService {
  private overlays = new Set<CdkConnectedOverlay>();

  register(overlay: CdkConnectedOverlay): void {
    if (overlay) {
      this.overlays.add(overlay);
    }
  }

  unregister(overlay: CdkConnectedOverlay): void {
    this.overlays.delete(overlay);
  }

  updatePositions(): void {
    this.overlays.forEach((overlay) => {
      if (overlay?.overlayRef?.hasAttached()) {
        overlay.overlayRef.updatePosition();
      }
    });
  }

  /** Detaches all registered CDK overlays. Each overlay fires its (detach) event, resetting the host component state. */
  closeAll(): void {
    this.overlays.forEach((overlay) => {
      if (overlay?.overlayRef?.hasAttached()) {
        overlay.overlayRef.detach();
      }
    });
  }
}
